const style = () => {
  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      borderTop: 'solid 1px rgba(0, 0, 0, .1)',
      paddingTop: 15,
      marginBottom: 20,
      '& h4': {
        display: 'block',
        padding: '0',
        textTransform: 'uppercase',
        fontSize: '14px',
        paddingRight: 30,
        fontWeight: 'bold',
        marginBottom: 14,
      },
    },
    arrow: {
      width: 14,
      height: 14,
      position: 'absolute',
      zIndex: 1,
      top: 16,
      right: 0,
      cursor: 'pointer',
      transform: 'scaleY(1)',
      '&:before': {
        content: '""',
        width: '9px',
        height: '2px',
        background: 'rgb(0, 0, 0)',
        display: 'block',
        position: 'absolute',
        top: '50%',
        borderTopLeftRadius: '1px',
        borderBottomLeftRadius: '1px',
        left: '0px',
        transform: 'translateY(-50%) rotate(46deg)',
      },
      '&:after': {
        content: '""',
        width: '9px',
        height: '2px',
        background: 'rgb(0, 0, 0)',
        display: 'block',
        position: 'absolute',
        top: '50%',
        borderTopRightRadius: '1px',
        borderBottomRightRadius: '1px',
        right: '0px',
        transform: 'translateY(-50%) rotate(-46deg)',
      },
    },
    group: {
      display: 'none',
    },
    visible: {
      '& $arrow': {
        transform: 'scaleY(-1)',
      },
      '& $group': {
        display: 'block',
      },
    },
  }

  return output
}

export default style
